import { RequestStatusEnum } from '@/helpers/consts';

export default {
  uploadCargaARRequestStatus: RequestStatusEnum.IDLE,
  selectedProduct: null,
};